// Lazy-load videos: only play when scrolled into view
// Rollback: remove this file + remove script tag from theme.liquid
(function() {
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var video = entry.target.querySelector('video');
        if (video) {
          video.preload = 'auto';
          video.play().catch(function() {});
        }
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px' });

  document.querySelectorAll('[data-lazy-video]').forEach(function(el) {
    observer.observe(el);
  });
})();
